import './product-variations.scss';
import { initSelectors } from '../../../assets/src/ts/utils/selector';

initSelectors();
